<template>
  <AnalyzerTable
    :headers="missingCorridorsTableHeaders"
    get-table-data-action="AnalyzerStore/getMissingCorridors"
    table-data-getter="AnalyzerStore/missingCorridors"
  />
</template>

<script>
import AnalyzerTable from "./AnalyzerTable";
import {missingCorridorsTableHeaders} from "@/utils/staticTablesColumns";

export default {
  name: "MissingCorridors",
  components: {
    AnalyzerTable
  },
  created() {
    this.missingCorridorsTableHeaders = missingCorridorsTableHeaders
  }
}
</script>

<style scoped>

</style>